// MyGoogleMaps.js
import React, { Component } from 'react';

import GoogleMapReact from 'google-map-react';
import Button from './HexButton/button'
import styled from 'styled-components';

import AutoComplete from './Autocomplete';
import Marker from './Marker';
import Markerimg from './images/marker.jpg';
import './auto.css'

const Wrapper = styled.main`
    width: 100%;
    height: 90vh;
    position:relative;
    align-items:center;
    display:flex;
    justify-content:center;
    margin-top:-75px
   `;

class MyGoogleMap extends Component {


    state = {
        mapApiLoaded: false,
        mapInstance: null,
        mapApi: null,
        geoCoder: null,
        places: [],
        center: [],
        zoom: 9,
        address: '',
        draggable: true,
        lat: null,
        lng: null
    };

    componentWillMount() {
        this.setCurrentLocation();
    }


    // onMarkerInteraction = (childKey, childProps, mouse) => {
    //     this.setState({
    //         draggable: false,
    //         lat: mouse.lat,
    //         lng: mouse.lng
    //     });
    // }
    // onMarkerInteractionMouseUp = (childKey, childProps, mouse) => {
    //     this.setState({ draggable: true });
    //     this._generateAddress();
    // }

    _onChange = ({ center, zoom }) => {
        console.log(center)
        this.setState({
            center: center,
            zoom: zoom,
            lat: center.lat,
            lng: center.lng
        });
        // setTimeout(() => {
        //     this._generateAddress();

        // }, 100);



    }

    // _onClick = (value) => {
    //     this.setState({
    //         lat: value.lat,
    //         lng: value.lng
    //     });
    // }

    apiHasLoaded = (map, maps) => {
        this.setState({
            mapApiLoaded: true,
            mapInstance: map,
            mapApi: maps,
        });

        // this._generateAddress();
    };

    addPlace = (place) => {
        this.setState({
            places: [place],
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        });
        // this._generateAddress()
    };

    // _generateAddress() {
    //     const {
    //         mapApi
    //     } = this.state;

    //     const geocoder = new mapApi.Geocoder;

    //     geocoder.geocode({ 'location': { lat: this.state.lat, lng: this.state.lng } }, (results, status) => {
    //         console.log(results);
    //         console.log(status);
    //         if (status === 'OK') {
    //             if (results[0]) {
    //                 this.zoom = 12;
    //                 this.setState({ address: results[0].formatted_address });
    //             } else {
    //                 window.alert('No results found');
    //             }
    //         } else {
    //             window.alert('Geocoder failed due to: ' + status);
    //         }

    //     });
    // }

    // Get Current Location Coordinates
    setCurrentLocation() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.setState({
                    center: [position.coords.latitude, position.coords.longitude],
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
            });
        }
    }

    handleChange(e) {
        console.log(e)
        console.log(this.state.lat, this.state.lng)
        this.props.latlag(this.state.lat, this.state.lng)
    }

    render() {
        const {
            places, mapApiLoaded, mapInstance, mapApi,
        } = this.state;


        return (
            <>

                {mapApiLoaded && (
                    <div>
                        <AutoComplete map={mapInstance} mapApi={mapApi} addplace={this.addPlace} />
                        <Button buttonTitle='Select' id="mapbutton"
                            onClick={(e) => this.handleChange(e)}
                        />
                    </div>
                )}

                <Wrapper>
                    <GoogleMapReact
                        // center={this.state.center}
                        center={{ lat: 28.404599599999997, lng: 77.30487599999998 }}
                        zoom={this.state.zoom}
                        // draggable={this.state.draggable}
                        onChange={this._onChange}
                        // onChildMouseDown={this.onMarkerInteraction}
                        // onChildMouseUp={this.onMarkerInteractionMouseUp}
                        // onChildMouseMove={this.onMarkerInteraction}
                        // onClick={this._onClick}
                        bootstrapURLKeys={{
                            key: 'AIzaSyBZhVJe_699r0rwfycOumQAD9unFlal_2g',
                            libraries: ['places', 'geometry'],
                        }}
                        yesIWantToUseGoogleMapApiInternals
                        onGoogleApiLoaded={({ map, maps }) => this.apiHasLoaded(map, maps)}
                    >


                        {/* <Marker 
                        text={this.state.address}
                        lat={this.state.lat}
                        lng={this.state.lng}
                    /> */}




                    </GoogleMapReact>

                    {/* <div className="info-wrapper">
                    <div className="map-details">Latitude: <span>{this.state.lat}</span>, Longitude: <span>{this.state.lng}</span></div>
                    <div className="map-details">Zoom: <span>{this.state.zoom}</span></div>
                    <div className="map-details">Address: <span>{this.state.address}</span></div>

                </div> */}
                    <div style={{ position: "absolute" }}>

                        {/* <div style={{width:"150px",fontSize:"10px",background:"white",padding:"5px",fontWeight:"bold"}}>
            <span>{this.state.address}</span>
            </div> */}
                        <img style={{ width: "55px" }} src={Markerimg} />
                    </div>

                </Wrapper >

                {/* <div style={{position:"absolute",top:"270px",left:"610px"}}> */}

            </>
        );
    }
}

export default MyGoogleMap;